import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { StyledButton } from 'components/Buttons';
import {
  buttons,
  deleteExternalActivity,
  confirmDeleteExternalActivity,
} from '../MappingModule.consts';
import * as S from './ConfirmDeleteDialog.css';

type Props = {
  open: boolean;
  count: number;
  onClose: () => void;
  onConfirm: () => void;
};

export const ConfirmDeleteDialog = ({ open, onClose, onConfirm }: Props) => (
  <S.StyledDialog open={open} onClose={onClose}>
    <DialogTitle>{deleteExternalActivity}</DialogTitle>
    <DialogContent dividers>
      <DialogContentText>{confirmDeleteExternalActivity}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <StyledButton $primary onClick={onConfirm}>
        {buttons.delete}
      </StyledButton>
      <StyledButton onClick={onClose}>{buttons.cancel}</StyledButton>
    </DialogActions>
  </S.StyledDialog>
);
